import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const CreditCardIconSvg = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.20947 0.200195C3.25221 0.200195 2.33415 0.580467 1.65726 1.25736C0.98037 1.93425 0.600098 2.8523 0.600098 3.80957V5.4502H21.6001V3.80957C21.6001 2.8523 21.2198 1.93425 20.5429 1.25736C19.866 0.580467 18.948 0.200195 17.9907 0.200195H4.20947ZM21.6001 6.7627H0.600098V12.3408C0.600098 13.2981 0.98037 14.2161 1.65726 14.893C2.33415 15.5699 3.25221 15.9502 4.20947 15.9502H17.9907C18.948 15.9502 19.866 15.5699 20.5429 14.893C21.2198 14.2161 21.6001 13.2981 21.6001 12.3408V6.7627ZM15.6938 12.0127H18.3188C18.4929 12.0127 18.6598 12.0818 18.7829 12.2049C18.906 12.328 18.9751 12.4949 18.9751 12.6689C18.9751 12.843 18.906 13.0099 18.7829 13.133C18.6598 13.2561 18.4929 13.3252 18.3188 13.3252H15.6938C15.5198 13.3252 15.3529 13.2561 15.2298 13.133C15.1067 13.0099 15.0376 12.843 15.0376 12.6689C15.0376 12.4949 15.1067 12.328 15.2298 12.2049C15.3529 12.0818 15.5198 12.0127 15.6938 12.0127Z"
      fill="currentColor"
    />
  </svg>
);

export const CreditCardIcon: FC<Partial<CustomIconComponentProps>> = (
  props
) => <Icon component={CreditCardIconSvg} {...props} />;

export default CreditCardIcon;

CreditCardIcon.displayName = "CreditCardIcon";
